import { isEqual } from 'lodash';

export function removeItemOnce<T>(arr: T[], value: T): T[] {
  const index = arr.indexOf(value);
  if (index > -1) {
    arr.splice(index, 1);
  }
  return arr;
}

export function removeItemAll<T>(arr: T[], value: T): T[] {
  let i = 0;
  while (i < arr.length) {
    if (arr[i] === value) {
      arr.splice(i, 1);
    } else {
      ++i;
    }
  }
  return arr;
}

export function isEqualDeep<T>(value1: T, value2: T): boolean {
  // Directly compare non-object types using isEqual
  if (
    typeof value1 !== 'object' ||
    value1 === null ||
    typeof value2 !== 'object' ||
    value2 === null
  ) {
    return isEqual(value1, value2);
  }

  // Now, both values are confirmed to be objects (and not null)
  const obj1 = value1 as Record<string, any>;
  const obj2 = value2 as Record<string, any>;

  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  const filteredKeys1 = keys1.filter((key) => typeof obj1[key] !== 'function');
  const filteredKeys2 = keys2.filter((key) => typeof obj2[key] !== 'function');

  if (filteredKeys1.length !== filteredKeys2.length) {
    return false;
  }

  for (const key of filteredKeys1) {
    if (!filteredKeys2.includes(key) || !isEqualDeep(obj1[key], obj2[key])) {
      return false;
    }
  }

  return true;
}